import * as React from "react";
import {
  EditOutlinedIcon,
  IconComponent,
  IconButton,
  IconButtonEdge,
  Text,
  TextVariant,
  useBrandColors,
} from "../../../ui";

/** The vehicle's notes under their label, always shown, with a pencil to edit them. */
export const NotesRow: React.FC<{
  label: string;
  Icon: IconComponent;
  notes: string | null;
  /** Without it the pencil shows greyed out: the record cannot be saved, or is busy. */
  onEdit?: () => void;
}> = ({ label, Icon, notes, onEdit }) => {
  const { primary } = useBrandColors();
  return (
    <div className="flex flex-col py-1 border-b border-[#44576e] last:border-b-0">
      <div className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 min-w-0">
          <Icon aria-hidden data-testid="spec-icon" style={{ fontSize: 18, color: "#94a3b8", flexShrink: 0 }} />
          <Text variant={TextVariant.BODY2} className="text-gray-400">
            {label}
          </Text>
        </span>
        <IconButton
          aria-label={notes ? "Edit notes" : "Add notes"}
          onClick={onEdit}
          disabled={!onEdit}
          edge={IconButtonEdge.END}
          // 44px tap target, greyed like the header's pencil when there is nothing it can do.
          style={{ padding: 12, flexShrink: 0, color: onEdit ? primary : "#64748b" }}
        >
          <EditOutlinedIcon style={{ fontSize: 20 }} />
        </IconButton>
      </div>
      {notes ? (
        <Text
          variant={TextVariant.BODY2}
          className="pb-2 whitespace-pre-wrap break-words"
          style={{ overflowWrap: "anywhere" }}
          data-testid="vehicle-notes"
        >
          {notes}
        </Text>
      ) : (
        <Text variant={TextVariant.BODY2} className="pb-2 text-gray-400" data-testid="vehicle-notes">
          No notes
        </Text>
      )}
    </div>
  );
};
